import { render, staticRenderFns } from "./schoolUser.vue?vue&type=template&id=e60b37ae&scoped=true&"
import script from "./schoolUser.vue?vue&type=script&lang=js&"
export * from "./schoolUser.vue?vue&type=script&lang=js&"
import style0 from "./schoolUser.vue?vue&type=style&index=0&id=e60b37ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60b37ae",
  null
  
)

export default component.exports